import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSubmitted(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.logo}>
          <span style={styles.logoTru}>Tru</span>
          <span style={styles.logoFlow}>Flow</span>
        </h1>

        <h2 style={styles.heading}>Forgot your password?</h2>
        <p style={styles.subheading}>Enter your email and we'll send you a reset link.</p>

        {submitted ? (
          <p style={styles.success}>
            If that email is registered you'll receive a reset link shortly. Check your inbox.
          </p>
        ) : (
          <form onSubmit={handleSubmit} noValidate>
            <div style={styles.field}>
              <label htmlFor="email" style={styles.label}>Email</label>
              <input
                id="email"
                type="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={styles.input}
                placeholder="you@example.com"
              />
            </div>

            {error && <p style={styles.error}>{error}</p>}

            <button type="submit" disabled={loading} style={styles.button}>
              {loading ? 'Sending…' : 'Send reset link'}
            </button>
          </form>
        )}

        <p style={styles.backText}>
          <Link to="/login" style={styles.backLink}>Back to login</Link>
        </p>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    backgroundColor: 'var(--paper)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px',
    boxSizing: 'border-box',
  },
  card: {
    backgroundColor: 'var(--card)',
    borderRadius: 'var(--r-card)',
    boxShadow: 'var(--sh-raise)',
    padding: '32px',
    width: '100%',
    maxWidth: '420px',
    boxSizing: 'border-box',
  },
  logo: {
    fontFamily: 'var(--font-serif)',
    fontSize: '2rem',
    fontWeight: '700',
    textAlign: 'center',
    margin: '0 0 24px 0',
    letterSpacing: '-0.5px',
  },
  logoTru: {
    color: 'var(--ink)',
  },
  logoFlow: {
    color: 'var(--signal)',
  },
  heading: {
    fontFamily: 'var(--font-serif)',
    fontSize: '1.25rem',
    fontWeight: '700',
    color: 'var(--ink)',
    margin: '0 0 8px 0',
  },
  subheading: {
    fontSize: '0.875rem',
    color: 'var(--slate)',
    margin: '0 0 24px 0',
    lineHeight: 1.5,
  },
  field: {
    marginBottom: '20px',
  },
  label: {
    display: 'block',
    fontSize: '0.875rem',
    fontWeight: '500',
    color: 'var(--slate)',
    marginBottom: '6px',
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    fontSize: '1rem',
    border: '1px solid var(--input-border)',
    borderRadius: '8px',
    outline: 'none',
    boxSizing: 'border-box',
    color: 'var(--ink)',
    backgroundColor: 'var(--card)',
  },
  error: {
    color: 'var(--stop)',
    fontSize: '0.875rem',
    margin: '0 0 16px 0',
    padding: '10px 12px',
    backgroundColor: 'var(--stop-soft)',
    border: '1px solid var(--stop-border)',
    borderRadius: '8px',
  },
  success: {
    fontSize: '0.875rem',
    color: 'var(--ink)',
    backgroundColor: 'var(--go-soft)',
    border: '1px solid var(--go-border)',
    borderRadius: '8px',
    padding: '12px',
    lineHeight: 1.5,
  },
  button: {
    width: '100%',
    padding: '11px',
    backgroundColor: 'var(--signal)',
    color: 'var(--on-signal)',
    fontSize: '1rem',
    fontWeight: '600',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    marginTop: '8px',
  },
  backText: {
    textAlign: 'center',
    fontSize: '0.875rem',
    color: 'var(--mute)',
    marginTop: '24px',
    marginBottom: '0',
  },
  backLink: {
    color: 'var(--signal)',
    textDecoration: 'none',
    fontWeight: '500',
  },
};
